import React from 'react';
import { formatNumber } from '../data';

const CategorySeats = ({ pools }) => {
  return (
    <div>
      <h3 className="font-semibold leading-[1.3] text-inherit text-[21px]">Places par catégorie</h3>
      <dl className="mt-3.5 text-sm">
        {pools.map((pool) => (
          <div
            key={pool.id}
            className="flex items-baseline justify-between gap-4 border-b border-[#e8ebe4] py-3 last:border-0"
          >
            <dt className="font-semibold text-[#30372d]">{pool.label}</dt>
            <dd className="text-right tabular-nums text-[#586357]">
              {formatNumber(pool.occupied)} / {formatNumber(pool.total)} places occupées
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default CategorySeats;
